var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',{staticClass:"nav-container"},[_c('navbar',{attrs:{"nav-index":_vm.navActiveIndex},on:{"nav-items-click":_vm.navClick}})],1),_c('el-container',[_c('el-main',{attrs:{"id":"crm-main-container"}},[_c('app-main')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }